import { render, staticRenderFns } from "./addBankDc.vue?vue&type=template&id=c754125a&scoped=true"
import script from "./addBankDc.vue?vue&type=script&lang=js"
export * from "./addBankDc.vue?vue&type=script&lang=js"
import style0 from "./addBankDc.vue?vue&type=style&index=0&id=c754125a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c754125a",
  null
  
)

export default component.exports